import React from "react";
import styles from "./specialAttributeDetail.scss";

const SpecialAttributeDetail = ({ title, value }) => (
  <React.Fragment>
    <span title={value} className={styles.value}>
      {value}
    </span>
    <span title={title} className={styles.title}>
      {title}
    </span>
  </React.Fragment>
);

export default SpecialAttributeDetail;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SpecialSectionMobile/SpecialAttributeCard/SpecialAttributeDetail/index.tsx